export default defineNuxtPlugin((nuxtApp) => {
  // Update GTM consent based on cookie consent choices
  if (process.env.NODE_ENV === 'production') {

    const updateGTMConsent = (analyticsAccepted, marketingAccepted = false) => {
      if (typeof window !== 'undefined' && window.gtag) {
        // console.log('Updating GTM consent - Analytics:', analyticsAccepted, 'Marketing:', marketingAccepted);

        window.gtag('consent', 'update', {
          'analytics_storage': analyticsAccepted ? 'granted' : 'denied',
          'ad_storage': marketingAccepted ? 'granted' : 'denied'
        });
      }
    };

    const checkConsent = () => {
      // Try multiple ways to access the cookie consent
      let CC = null;

      // Method 1: Via Nuxt provide
      if (nuxtApp.$CC) {
        CC = nuxtApp.$CC;
      }
      // Method 2: Via window.CC (fallback)
      else if (typeof window !== 'undefined' && window.CC) {
        CC = window.CC;
      }
      // Method 3: Direct import check
      else if (typeof window !== 'undefined' && window.CookieConsent) {
        CC = window.CookieConsent;
      }

      if (CC && typeof CC.acceptedCategory === 'function') {
        const analyticsAccepted = CC.acceptedCategory('analytics');
        const marketingAccepted = CC.acceptedCategory('marketing');

        // console.log('Consent status - Analytics:', analyticsAccepted, 'Marketing:', marketingAccepted);
        updateGTMConsent(analyticsAccepted, marketingAccepted);
      } else {
        // console.log('Cookie consent not ready yet, retrying...');
        // Retry after a short delay
        setTimeout(checkConsent, 200);
      }
    };

    // Listen for consent events
    if (typeof window !== 'undefined') {
      document.addEventListener('cc:onConsent', () => {
        // console.log('Cookie consent granted event');
        setTimeout(checkConsent, 100);
      });

      document.addEventListener('cc:onChange', () => {
        // console.log('Cookie consent changed event');
        setTimeout(checkConsent, 100);
      });
    }

    // Check consent after cookie consent plugin loads
    const initializeGTMConsent = () => {
      // Wait a bit longer for cookie consent to initialize
      setTimeout(checkConsent, 1000);

      // Also check periodically in case of timing issues
      let retries = 0;
      const checkInterval = setInterval(() => {
        retries++;
        checkConsent();

        // Stop after 10 retries (20 seconds)
        if (retries >= 10) {
          clearInterval(checkInterval);
        }
      }, 2000);
    };

    // Initialize based on document ready state
    if (typeof window !== 'undefined') {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeGTMConsent);
      } else {
        // DOM is already loaded
        initializeGTMConsent();
      }
    }
  }
});
